export const LockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 4.5C4.5 2.567 6.067 1 8 1C9.933 1 11.5 2.567 11.5 4.5V6.5C12.6046 6.5 13.5 7.39543 13.5 8.5V13C13.5 14.1046 12.6046 15 11.5 15H4.5C3.39543 15 2.5 14.1046 2.5 13V8.5C2.5 7.39543 3.39543 6.5 4.5 6.5V4.5ZM4.5 7.5C3.94772 7.5 3.5 7.94772 3.5 8.5V13C3.5 13.5523 3.94772 14 4.5 14H11.5C12.0523 14 12.5 13.5523 12.5 13V8.5C12.5 7.94772 12.0523 7.5 11.5 7.5H4.5ZM10.5 6.5H5.5V4.5C5.5 3.11929 6.61929 2 8 2C9.38071 2 10.5 3.11929 10.5 4.5V6.5Z"
        fill="#8E9296"
      />
    </svg>
  );
};
